import * as React from "react";
import { forwardRef } from "react";
const SvgEyeCrossed = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M30.977 15.098a5 5 0 0 0-3.75.742 5 5 0 0 0-1.387 6.933l40 60a5 5 0 0 0 6.933 1.387 5 5 0 0 0 1.387-6.933l-40-60a5 5 0 0 0-3.183-2.13M50 21.992c-2.205 0-4.3.188-6.309.508L50 31.973c9.204.07 18.008 7.23 18.008 18.027 0 2.448-.502 4.786-1.387 6.914l8.223 12.324C85.278 61.025 90 50 90 50S78 21.992 50 21.992m-24.844 8.77C14.722 38.975 10 50 10 50s12 28.008 40 28.008c2.205 0 4.3-.207 6.309-.528L50 68.008h-.02c-13.526-.014-21.347-13.84-16.64-24.961Z" />
  </svg>
);
const ForwardRef = forwardRef(SvgEyeCrossed);
export default ForwardRef;
